import classNames from 'classnames';
import React from 'react'

const ListItem = ({ label, labelIcon, value, className, visible = true, extra }) => {
  if (!visible) return null;
  return (
    <div
      className={classNames(`list-item`, {
        [className]: className,
      })}
    >
      {labelIcon !== undefined && <span className="label-icon mr-2">{labelIcon}</span>}
      {label !== undefined && <span className="label">{label}</span>}
      {value !== undefined && <span className="value">{value}</span>}
      {extra !== undefined && <span className="extra">{extra}</span>}
    </div>
  );
};

const ListItems = ({ className, layout = 'horizontal', children }) => {
  return (
    <div
      className={classNames(`list-items`, {
        [`list-items--${layout}`]: layout,
        [className]: className,
      })}
    >
      {children}
    </div>
  );
};

export { ListItems, ListItem };